import { FunctionComponent } from 'react'
import styles from './planningKPI.module.scss'
import { CalendarEventType } from '@/types/Calendar.ts'
import Indicator from '@/components/_custom/Indicator/indicator.tsx'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { PlanningTabId } from '@/hooks/usePlanningRights.ts'

interface OccasionalKPIProps {
    planningActiveTab: PlanningTabId
    filterEvents: (filters: string[]) => void
    merger: boolean
    requestedHours: number
    scheduledHours: number
    availableHours: number
    validatedHours: number
    isParent: boolean
}

const OccasionalKPI: FunctionComponent<OccasionalKPIProps> = ({
    planningActiveTab,
    filterEvents,
    merger,
    requestedHours,
    scheduledHours,
    availableHours,
    validatedHours,
    isParent
}: OccasionalKPIProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    return (
        <>
            {requestedHours > 0 && (
                <a
                    className={styles.IndicatorClickable}
                    href={`/request?type=slot&tab=${planningActiveTab}`}
                    onClick={(e) => {
                        if (!(e.ctrlKey || e.metaKey)) {
                            e.preventDefault()
                            navigate(`/request?type=slot&tab=${planningActiveTab}`)
                        }
                    }}
                >
                    <Indicator
                        count={requestedHours}
                        parent={isParent}
                        size={'m'}
                        text={requestedHours > 1 ? t('regularRequestsWaiting') : t('regularRequestWaiting')}
                        className={styles.Indicator}
                        badge={'request'}
                    />
                </a>
            )}
            {scheduledHours > 0 && (
                <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.SCHEDULED])}>
                    <Indicator
                        count={scheduledHours}
                        parent={isParent}
                        size={'m'}
                        text={
                            scheduledHours > 1
                                ? merger
                                    ? t('scheduleHours')
                                    : t('scheduleSlots')
                                : merger
                                  ? t('scheduleHour')
                                  : t('scheduleSlot')
                        }
                        className={styles.Indicator}
                        badge={'schedule'}
                    />
                </a>
            )}
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.AVAILABLE])}>
                <Indicator
                    count={availableHours}
                    parent={isParent}
                    size={'m'}
                    text={
                        availableHours > 1
                            ? merger
                                ? t('availableHours')
                                : t('availableSlots')
                            : merger
                              ? t('availableHour')
                              : t('availableSlot')
                    }
                    className={styles.Indicator}
                    badge={'available'}
                />
            </a>
            <a className={styles.IndicatorClickable} onClick={() => filterEvents([CalendarEventType.VALIDATED])}>
                <Indicator
                    count={validatedHours}
                    parent={isParent}
                    size={'m'}
                    text={
                        validatedHours > 1
                            ? merger
                                ? t('validatedHours')
                                : t('validatedSlots')
                            : merger
                              ? t('validatedHour')
                              : t('validatedSlot')
                    }
                    className={styles.Indicator}
                    badge={'booked'}
                />
            </a>
        </>
    )
}

export default OccasionalKPI
